import type { MetaFunction } from 'react-router';

import { canonicalTag } from '@jane/bloom/resources/meta/canonicalTag';
import { description } from '@jane/bloom/resources/meta/description';
import { getRootLoaderData } from '@jane/bloom/resources/meta/getRootLoaderData';
import { parentMeta } from '@jane/bloom/resources/meta/parentMeta';
import { title } from '@jane/bloom/resources/meta/title';
import type { loader } from '@jane/bloom/routes/_menu.$basename.jane-gold.$specialId.$slug/route';

export const janeGoldSpecialDetailRouteMeta: MetaFunction<typeof loader> = (
  args
) => {
  const {
    menuUrl,
    metaProps: {
      fulfillmentMode,
      pinnedStoreCity,
      pinnedStoreName,
      pinnedStoreState,
      reservationMode,
    },
  } = getRootLoaderData(args);
  const data = args.loaderData;

  return [
    title(
      `Shop ${data?.currentSpecial?.title} products`,
      `${pinnedStoreName} Dispensary ${pinnedStoreCity}, ${pinnedStoreState}`
    ),
    description(
      `Visit ${pinnedStoreName} dispensary in ${pinnedStoreCity}, ${pinnedStoreState} and order ${fulfillmentMode} cannabis online products for ${reservationMode}. Browse our online dispensary menu for flower, edibles, vape and more.`
    ),
    canonicalTag(args.location, menuUrl),
    ...parentMeta(args),
  ];
};
